<script lang="ts">
	import { page } from '$app/stores';
	import { faBars, faLanguage, faRightToBracket, faUser } from '@fortawesome/free-solid-svg-icons';
	import { t } from '$lib/i18n/translation';
	// noinspection ES6UnusedImports
	import Fa from 'svelte-fa';
	import { user } from '$lib/stores/user';
	import type { ClientSessionObject } from '$lib/auth';

	interface NavigationLink {
		href: string;
		lookup: string;
	}

	$: isLoggedIn = !!$user;
	$: elements = getNavigationElements($user);

	const loggedInElements: Array<NavigationLink> = [
		{
			href: '/account/general',
			lookup: 'account'
		},
		{
			href: '/logout',
			lookup: 'logout'
		}
	];

	function getNavigationElements(user: ClientSessionObject | undefined) {
		const elements = [
			{
				href: '/download',
				lookup: 'play_now'
			},
			{
				href: '/news',
				lookup: 'news'
			},
			{
				href: '/leaderboard',
				lookup: 'leaderboard'
			}, {
				href: '/shop',
				lookup: 'shop'
			}
		];

		if (!user) {
			elements.push({
				href: '/sign-up',
				lookup: 'sign_up'
			});
		}

		return elements;
	}
</script>

<div class="bg-base-200 border-b border-base-300 text-base-content sticky z-10 shadow-md">
	<div class="container mx-auto flex flex-row align-middle py-1">
		<!-- Home button. -->
		<div class="flex-none flex grow">
			<a class="btn btn-ghost px-0" href="/">
				<img class="w-[64px] h-full object-contain" src="/favicon.png" alt="Icon" />
			</a>
		</div>

		<!-- Login / account button. -->
		<div class="flex-none flex">
			{#if isLoggedIn}
				<div class="dropdown dropdown-end">
					<ul class="menu menu-horizontal">
						<li>
							<a class:active={$page.route.id?.includes('/login')} href="#"
							   class="font-bold bg-base-100 max-w-[50vw]">
								<Fa class="text-lg" fw={true} icon={faUser}></Fa>
								<span class="truncate">{$user?.displayName}</span>
							</a>
						</li>
					</ul>
					<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
					<ul tabindex="0" class="menu dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-lg">
						{#each loggedInElements as element}
							<li><a class:active={$page.route.id?.includes(element.href)}
								   href={element.href}>{$t(`navigation.${element.lookup}`)}</a></li>
						{/each}
					</ul>
				</div>
			{:else}
				<ul class="menu menu-horizontal hidden lg:block">
					<li>
						<a class:active={$page.route.id?.includes('/login')} href="/login">{$t('navigation.login')}</a>
					</li>
				</ul>
			{/if}
		</div>

		<!-- Desktop navigation. -->
		<div class="flex-none hidden lg:flex">
			<ul class="menu menu-horizontal">
				{#each elements as element}
					<li><a class:active={$page.route.id?.includes(element.href)}
						   href={element.href}>{$t(`navigation.${element.lookup}`)}</a></li>
				{/each}
				<li>
					<a href="/switch-language">
						<Fa icon={faLanguage} fw={true} class="text-xl"></Fa>
					</a>
				</li>
			</ul>
		</div>

		<!-- Mobile alternative navigation. -->
		<div class="flex-none flex lg:hidden">
			<div class="dropdown dropdown-end">
				<div tabindex="0" role="button" class="btn btn-ghost focus:bg-base-100">
					<Fa class="text-xl" fw={true} icon={faBars}></Fa>
				</div>
				<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
				<ul tabindex="0" class="menu dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-lg">
					{#if !isLoggedIn}
						<li>
							<a class:active={$page.route.id?.includes('/login')} href="/login">
								{$t('navigation.login')}
								<Fa fw={true} icon={faRightToBracket}></Fa>
							</a>
						</li>
					{/if}

					{#each elements as element}
						<li>
							<a class:active={$page.route.id?.includes(element.href)} href={element.href}>
								{$t(`navigation.${element.lookup}`)}
							</a>
						</li>
					{/each}

					<li>
						<a href="/switch-language">
							{$t('navigation.languages')}
							<Fa icon={faLanguage} fw={true}></Fa>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>

<style>
    .active {
        @apply text-accent bg-base-300 !important;
    }
</style>
